import script from "./currentAssetTrade.vue?vue&type=script&setup=true&lang=js"
export * from "./currentAssetTrade.vue?vue&type=script&setup=true&lang=js"

import "./currentAssetTrade.vue?vue&type=style&index=0&id=783c5670&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783c5670"]])

export default __exports__